import React, { useState, useMemo } from "react"
import Input from "@infotech/uikit-input"
import isArray from "lodash/isArray"
import { SearchIcon, CloseIcon } from "@infotech/uikit-icons"
import { Box } from "@infotech/uikit-grid"
import { SecondaryPrimaryButton, FlatButton } from "@infotech/uikit-button"

const ResourceSearch = ({
  filterCalendarBy,
  resourceNameFilter,
  getAttribute,
}) => {
  const { setResourceNameFilter } = filterCalendarBy
  const initialValue =
    typeof resourceNameFilter === `string` ? resourceNameFilter : ``
  const [value, setValue] = useState(initialValue)
  const isSearchApply = isArray(resourceNameFilter)
    ? resourceNameFilter.length
    : resourceNameFilter

  useMemo(() => {
    setValue(initialValue)
  }, [initialValue])
  return (
    <Box loose flex row>
      <Box loose w="180px" data-testid={getAttribute(`resource-search-input`)}>
        <Input
          placeholder="Поиск по ресурсам"
          value={value}
          onValueChange={value => setValue(value)}
        />
      </Box>
      <Box loose pl="1md" data-testid={getAttribute(`resource-search-button`)}>
        <SecondaryPrimaryButton
          onClick={() => setResourceNameFilter(value)}
          icon={SearchIcon}
        />
      </Box>
      {Boolean(isSearchApply) && (
        <Box loose pl="1md" data-testid={getAttribute(`resource-search-clear`)}>
          <FlatButton
            onClick={() => setResourceNameFilter(null)}
            icon={CloseIcon}
          />
        </Box>
      )}
    </Box>
  )
}

export default ResourceSearch
